/**
 * @generated SignedSource<<0a21e16b82f27d1f6ed87d1056dd67f6>>
 * @relayHash 80ab77cb5bfdc03ecef8d33426926d48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1c5f1cbccdff8100441a4961dee1cc490bb58d274129bf4fd4ec80d8dc0d9e59

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { MergedDashboardsContent_dashboardsQuery } from './MergedDashboardsContent_dashboardsQuery.graphql';

const node: PreloadableConcreteRequest<MergedDashboardsContent_dashboardsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1c5f1cbccdff8100441a4961dee1cc490bb58d274129bf4fd4ec80d8dc0d9e59",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "avp_getDashboardsByStatus"
          ]
        }
      ]
    },
    "name": "MergedDashboardsContent_dashboardsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
